const getTickerIntervalSnapValue = (value: number) => {
  if (value > 10000) {
    return Math.round(value / 10000) * 10000;
  }
  if (value > 1000) {
    return Math.round(value / 1000) * 1000;
  }
  return Math.round(value / 100) * 100;
};

export default getTickerIntervalSnapValue;
